export const tabs = [
  { label: '文献库', path: '/home', icon: 'chanpinxinxi' },
  { label: '我的图书馆', path: '/library', icon: 'yixueyuandi' },
  { label: '个人中心', path: '/profile', icon: 'gerenzhongxin' }
]
